<template>
  <BaseEdit
    @edit-open-action="loadServerEntry(entry.id)"
    ref="baseEdit"
    :readTitle="'Extrato Bancário' + ($vuetify.breakpoint.xsOnly ? '' : (' - Conta: ' + entry.name))"
    width="90%"
    :loading="loading"
    :pageLoading="pageLoading"
    readIcon="mdi-chart-bar"
    :readOnly="true"
  >
    <template slot="editForm">
      <v-card>  
        <v-card-title>
          <span>Filtros</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="periodFilterModel"
                label="Período"
                :items="periodFilterOptions"
                item-value="key"
                item-text="name"
              />
            </v-col>
            <v-col cols="12" sm="5" v-if="periodFilterModel == 'OTHER'">
              <DateRangeField
                :inputData.sync="periodFilterRangeModel"
                label="Período Customizado"
                :hasTodayDate="true"
              />
            </v-col>

            <!-- <v-col cols="3">
              <v-autocomplete
                v-model="bankAccountFilterModel"
                label="Conta Bancária"
                :items="bankAccountsList"
                item-value="id"
                item-text="name"
              />
            </v-col> -->

            <v-col cols="12" sm="3">
              <v-btn
                class="mt-3"
                @click="runFilter">
                <v-icon left>mdi-magnify</v-icon>
                Filtrar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
        <!-- </v-col> -->

      <!-- </v-row> -->
      <!-- sortByField="dueDate" -->
      <!-- :sortDesc="false" -->

      <!-- <div>
        <BasePrint
          printableElementId="cashBookReportPrintTable"
          printButtonLabel="Imprimir"
          printTitle="Relatório de Fluxo de Caixa"
          @start-printing="printing = loading = true"
          @stop-printing="printing = loading = false"
          class="mt-3"
        />
      </div> -->

      <div id="bankStatementReportPrintTable">

        <v-row>
          <v-col cols="12" class="mt-6">
            <BaseIndex
              ref="baseIndex"
              v-if="cashBook"
              :loading="loading"
              :pageLoading="pageLoading"
              :table-headers="tableHeaders"
              :table-items="cashBook.installments"
              :maskFields="maskFields"
              :itemClass="itemClasses"
              :enableCustomFilters="false"
              :containTopToolbar="false"
              :containSearchBar="false"
              :itemsPerPage="-1"
              :disablePagination="true"
              :indexNested="true"
              :hasTableTitle="true"
              :tableTitle="'Extrato Bancário - Conta: ' + entry.name"
            >

              <template slot="edit" slot-scope="{ item }">
              <CashOutflowInstallmentEdit
                v-if="item.type == 'CashOutflowInstallment'"
                :entry="item"
                :editOnly="true"
                :readOnly="true"
              />
              <CashInflowInstallmentEdit
                v-else-if="item.type == 'CashInflowInstallment'"
                :entry="item"
                :editOnly="true"
                :readOnly="true"
              />
            </template>

            <template slot="link1" slot-scope="{ item }">
              <PurchaseEdit
                v-if="item.parentType == 'Purchase'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
              />
              <SaleEdit
                v-else-if="item.parentType == 'Sale'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
              />
              <ServiceProvisionEdit
                v-else-if="item.parentType == 'ServiceProvision'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
              />
              <CashInflowEdit
                v-else-if="item.parentType == 'CashInflow'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
              />
              <CashOutflowEdit
                v-else-if="item.parentType == 'CashOutflow'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
              />
              <DepositEdit
                v-else-if="item.parentType == 'Deposit'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
              />
              <TransferEdit
                v-else-if="item.parentType == 'Transfer'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
              />
              <WithdrawEdit
                v-else-if="item.parentType == 'Withdraw'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
              />
            </template>
            
              <template slot="tableHeader">
                <tr class="d-none d-md-table-row">
                  <td colspan="5" class="text-right title"><strong class="mx-3">Data de Início:</strong></td>
                  <td class="text-left title"><strong>{{ this.cashBook.startDate | formatDate }}</strong></td>
                  <td colspan="3" class="text-right title"><strong class="mx-3">Saldo Anterior:</strong></td>
                  <td colspan="2" class="text-left title"><strong>{{ this.cashBook.previousBalance | formatCurrency }}</strong></td>
                </tr>

                <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Data de Início</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashBook.startDate | formatDate }}</strong></div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Saldo Anterior</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashBook.previousBalance | formatCurrency }}</strong></div>
                </td>
              </tr>
              </template>

              <template slot="tableFooter">
                <tr class="d-none d-md-table-row">
                  <td colspan="5" class="text-right title"><strong class="mx-3">Data de Fim:</strong></td>
                  <td class="text-left title"><strong>{{ this.cashBook.endDate | formatDate }}</strong></td>
                  <td colspan="3" class="text-right title"><strong class="mx-3">Saldo Final:</strong></td>
                  <td colspan="2" class="text-left title"><strong>{{ this.cashBook.latestBalance | formatCurrency }}</strong></td>
                </tr>

                <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Data de Fim</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashBook.endDate | formatDate }}</strong></div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Saldo Final</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashBook.latestBalance | formatCurrency }}</strong></div>
                </td>
              </tr>
              </template>
            </BaseIndex>
          </v-col>
        </v-row>
      </div>
    </template>

    <template slot="action1">
      <BasePrint
        printableElementId="bankStatementReportPrintTable"
        printButtonLabel="Imprimir Extrato Bancário"
        :printTitle="'Extrato Bancário - Conta: ' + entry.name"
        @start-printing="printing = true"
        @stop-printing="printing = false"
        :disabledPrint="entry && entry.id ? false : true"
      />
    </template>
  </BaseEdit>
</template>

<script>
import BaseEdit from "@shared_components/base_edit.vue";
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";
import PurchaseEdit from "@models/purchases/edit.vue";
import SaleEdit from "@models/sales/edit.vue";
import ServiceProvisionEdit from "@models/services_provision/edit.vue";
import CashInflowEdit from "@models/cash_flows/cash_inflows/edit.vue";
import CashOutflowEdit from "@models/cash_flows/cash_outflows/edit.vue";
import DepositEdit from "@models/bank_accounts/bank_account_operations/deposits/edit.vue";
import TransferEdit from "@models/bank_accounts/bank_account_operations/transfers/edit.vue";
import WithdrawEdit from "@models/bank_accounts/bank_account_operations/withdraws/edit.vue";
import CashOutflowInstallmentEdit from "@models/installments/cash_outflow_installments/edit.vue";
import CashInflowInstallmentEdit from "@models/installments/cash_inflow_installments/edit.vue";

export default {
  data() {
    return {
      loading: true,
      pageLoading: false,
      cashBook: null,
      // bankAccountsList: [],
      // bankAccountFilterModel: "0",
      monthFilter: moment().format('YYYY-MM'),
      startDate: null,
      endDate: null,
      tableHeaders: [
        { text: "Código", align: "left", sortable: false, value: "customCode"},
        { text: "Nº da NF-e", align: "left", sortable: false, value: "number"},
        // { text: "Operação", align: "left", sortable: false, value: "operationTypeText"},
        { text: "Operação", align: "left", sortable: false, value: "link" },
        // { text: "Status", align: "left", sortable: false, value: "status" },
        { text: "Cliente/Fornecedor", align: "left", sortable: false, value: "payment.cashFlow.customerOrSupplierName" },
        { text: "Plano de Contas", align: "left", sortable: false, value: "payment.cashFlow.chart.name"},
        // { text: "Conta Bancária", align: "left", sortable: false, value: "bankAccount.name"},
        // { text: "Vencimento", align: "left", sortable: false, value: "dueDate"},
        { text: "Pagamento", align: "left", sortable: false, value: "paymentDate"},
        { text: "Valor da Parcela", align: "left", sortable: false, value: "value"},
        { text: "Valor Pago", align: "left", sortable: false, value: "totalOutPaidAmount"},
        { text: "Valor Recebido", align: "left", sortable: false, value: "totalInPaidAmount"},
        { text: "Saldo", align: "left", sortable: false, value: "partialBalance" },
        { text: "Ver", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'dueDate', mask: 'date' },
        { field: 'paymentDate', mask: 'date' },
        { field: 'value', mask: 'currency' },
        { field: 'totalOutPaidAmount', mask: 'currency' },
        { field: 'totalInPaidAmount', mask: 'currency' },
        { field: 'partialBalance', mask: 'currency' },
        // { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ],
      periodFilterOptions: [
        { "key": "DAY", "name": "Hoje" },
        { "key": "WEEK", "name": "Esta Semana" },
        { "key": "MONTH", "name": "Este Mês" },
        { "key": "OTHER", "name": "Customizado" },
      ],
      periodFilterModel: "DAY",
      periodFilterRangeModel: [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')]
    };
  },
  props: {
    entry: Object,
  },
  components: {
    BaseEdit: BaseEdit,
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
    PurchaseEdit: PurchaseEdit,
    SaleEdit: SaleEdit,
    ServiceProvisionEdit: ServiceProvisionEdit,
    CashInflowEdit: CashInflowEdit,
    CashOutflowEdit: CashOutflowEdit,
    DepositEdit: DepositEdit,
    TransferEdit: TransferEdit,
    WithdrawEdit: WithdrawEdit,
    CashOutflowInstallmentEdit: CashOutflowInstallmentEdit,
    CashInflowInstallmentEdit: CashInflowInstallmentEdit,
  },
  created() {
    if (this.entry) {
      // this.bankAccountFilterModel = this.entry.bankAccountId;
      this.periodFilterModel = "MONTH";
    }
    this.runFilter();
  },
  mounted() {

  },
  methods: {
    loadServerEntry: function(id) {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CASH_BOOK,
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
            bankAccountIds: [id]
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.cashBook = response.data.accountContext.cashBookReport;
          if (!this.cashBook) {
            this.cashBook = {installments: []};
          }
          // this.bankAccountsList = [{"id": "0", "name": "Todas as Contas Bancárias"}].concat(response.data.accountContext.allBankAccounts);
          // this.bankAccountsList.prepend({"id": "", "name": "Todas Contas Bancárias"});
          // console.log("cashBook", this.cashBook);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    itemClasses: function(item) {
      // if (item.status == "pending_payment") {
        if (item.type == "CashOutflowInstallment") {
          return "cash_outflow_item";
        } else if (item.type == "CashInflowInstallment") {
          return "cash_inflow_item";
        }
      // }
    },
    runFilter: function() {
      if (this.periodFilterModel != "OTHER") {
        this.startDate = moment().startOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
        this.endDate   = moment().endOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');

      } else {
        if (this.periodFilterRangeModel.length == 2) {
          this.startDate = this.periodFilterRangeModel[0];
          this.endDate   = this.periodFilterRangeModel[1];
        }
      }
      // console.log(this.startDate, this.endDate);
      this.loadServerEntry(this.entry.id);
      // this.startDate = moment(this.monthFilter, 'YYYY-MM').startOf('week').format('YYYY-MM-DD');
      // this.endDate   = moment(this.monthFilter, 'YYYY-MM').endOf('week').format('YYYY-MM-DD');
    },
  }
};
const LOAD_CASH_BOOK = gql `
query ($startDate: ISO8601Date!, $endDate: ISO8601Date!, $bankAccountIds: [ID!]!) {
  accountContext {
    cashBookReport(startDate: $startDate, endDate: $endDate, bankAccountIds: $bankAccountIds) {
      previousBalance
      latestBalance
      startDate
      endDate
      installments {
        id
        customCode
        bankAccount {
          name
        }
        value
        paidAmount
        totalPaidAmount
        totalOutPaidAmount
        totalInPaidAmount
        dueDate
        series
        number
        payment {
          cashFlow {
            chart {
              name
            }
            supplier {
              name
            }
            customer {
              name
            }
            customerOrSupplierName
          }
        }
        code
        paymentDate
        type
        operationTypeText
        parentType
        parentId
        parentObject
        status
        statusKey
        statusColor
        partialBalance
      }
    }
    allBankAccounts {
      id
      name
    }
  }
}
`;

</script>

<style scoped>
  ::v-deep .cash_inflow_item {
    color: blue;
  }
  ::v-deep .cash_outflow_item {
    color: red;
  }
</style>